const TERM_SHEET_SCENARIOS = {
  active: "ACTIVE",
  merged: "MERGED",
  deleted: "DELETED",
};

export default TERM_SHEET_SCENARIOS;
